var map = {
	"./Alumni-IMG.jpg": "0544",
	"./Alumni-IMGCopy.jpg": "dfd1",
	"./Brick Plaza Rendering _ Feb.jpeg": "26ab",
	"./ben-meet.jpg": "5190",
	"./ben-paint.jpg": "29fb",
	"./ben-party.jpg": "c111",
	"./ben-photo-night.jpg": "7b39",
	"./ben-skate.jpg": "0f8b",
	"./brick-image.jpg": "d32b",
	"./family2.jpg": "d492",
	"./tunnel1.jpeg": "a1f0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7f88";